export default "__VITE_ASSET__DADelm0o__"